import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import modals from './modules/modals';
import departments from './endpoints/departments';
import forms from './endpoints/forms';
import dataInventory from './endpoints/data-inventory';
import surveys from './endpoints/surveys';
import privileges from './endpoints/privileges';
import agents from './endpoints/agents';
import admins from './endpoints/admins';
import channels from './endpoints/channels';
import calls from './endpoints/calls';
import queues from './endpoints/queues';
import users from './endpoints/users';
import widget from './endpoints/widget';
import account from './endpoints/account';
import MetricsCalls from './endpoints/metrics/calls';
import AvgCalls from './endpoints/metrics/avg';
import MetricsSLA from './endpoints/metrics/sla';
import MetricsAgents from './endpoints/metrics/agents';
import MetricsReports from './endpoints/metrics/reports';
import MetricsAppointments from './endpoints/metrics/appointments';
import MetricsIndicators from './endpoints/metrics/indicators';
import formsSubmissions from './endpoints/form-submissions';
import HelpCenter from './modules/help_center';
import security from './endpoints/security';
import webhooks from './endpoints/webhooks';
import webhooksSecrets from './endpoints/webhooks-secrets';
import webhooksLogs from './endpoints/webhooks-logs';
import tags from './endpoints/tags';
import availabilities from './endpoints/availabilities';
import services from './endpoints/services';
import records from './endpoints/records';
import recordingsSettings from './endpoints/recordings-settings';
import abandonReasons from './endpoints/abandonReasons';
import customEmails from './endpoints/custom-emails';
import agentFormsExport from './endpoints/agent-forms-export';
import userConnectionLogs from './endpoints/user-connection-logs';
import notifications from './endpoints/notifications';
import integrations from './endpoints/integrations';
import appointments from './endpoints/appointments';
import branches from './endpoints/branches';
import referrers from './endpoints/referrers';
import aiTopics from './endpoints/aiTopics';
import workingHours from './endpoints/working-hours';
import contacts from './endpoints/contacts';
import auditLogs from './endpoints/audit-logs';
import extensions from './endpoints/extensions';
import contentBlocks from './endpoints/content-blocks';
import liveMonitor from './modules/live-monitor';
import monitorViews from './endpoints/monitor-views';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    modals,
    departments,
    privileges,
    agents,
    admins,
    channels,
    calls,
    queues,
    users,
    widget,
    account,
    forms,
    'data-inventory': dataInventory,
    MetricsCalls,
    AvgCalls,
    MetricsSLA,
    MetricsAgents,
    MetricsReports,
    MetricsAppointments,
    MetricsIndicators,
    HelpCenter,
    'forms-submissions': formsSubmissions,
    security,
    webhooks,
    webhooksSecrets,
    webhooksLogs,
    tags,
    availabilities,
    services,
    surveys,
    records,
    'recordings-settings': recordingsSettings,
    abandonReasons,
    'custom-emails': customEmails,
    'agent-forms-export': agentFormsExport,
    userConnectionLogs,
    notifications,
    integrations,
    appointments,
    branches,
    referrers,
    aiTopics,
    'working-hours': workingHours,
    contacts,
    'audit-logs': auditLogs,
    extensions,
    'content-blocks': contentBlocks,
    'live-monitor': liveMonitor,
    'monitor-views': monitorViews,
  },
});
